import { useNavigate, useRouteError } from 'react-router';
import { FaFaceDizzy } from 'react-icons/fa6';

const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center gap-5">
      <h1 className="mb-4 flex items-center gap-5 text-4xl font-bold text-red-600">
        <FaFaceDizzy size={40} />
        無法訪問此頁面
      </h1>
      <div className="flex flex-col items-center justify-center gap-2.5">
        <p className="mb-2 text-lg text-gray-600">抱歉，您訪問的頁面不存在或發生錯誤。</p>
        {error && (
          <p className="text-sm text-gray-500">
            錯誤詳情:
            {' '}
            {error.message || error.statusText}
          </p>
        )}
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mt-4 rounded bg-primary-400 px-4 py-2 text-white hover:bg-primary-500"
        >
          返回上一頁
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
